import React from 'react'

class AuditEntryList extends React.Component {
  typeColor(Categoria) {
    const map = {
      INFO: '#28a745',
      CHANGE: '#ffc107',
      MONEY: '#f48c42',
      LOGIN: '#0077ff',
      INFO_LOCKERS: '#28fe75',
      QC: '#a600ff',
    }
    return map[Categoria] || '#ff0000'
  }

  render() {
    return (
      <div style={{ overflowX: 'auto' }}>
        <table className="audit-table">
          <thead>
            <tr>
              <th>Máquina</th>
              <th>Fecha/Hora</th>
              <th>Tipo</th>
              <th>Pin / Trabajador</th>
              <th>Evento</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            {this.props.audits.map(audit => (
              <tr key={audit._id}>
                <td className="audit-td-machine">{audit.Machine.Serial}</td>
                <td className="audit-td-time">{(new Date(audit.TimeStamp)).toLocaleString('es-ES', { timeZone: 'UTC' })}</td>
                <td>
                  <span className="audit-type-badge" style={{ backgroundColor: this.typeColor(audit.Categoria) }}>
                    {audit.Categoria}
                  </span>
                </td>
                <td>{audit.WorkerSession}</td>
                <td>{audit.Evento}</td>
                <td className="audit-td-desc">{audit.Description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default AuditEntryList

